import React from 'react';
import { Col, FormGroup, Label } from 'reactstrap';
import { Card, Input } from 'components';
import { State } from 'interfaces/state';

interface Props {
    state: State;
}

export default function GoogleTagManager({ state }: Props) {
    return (
        <>
            <Card>
                <FormGroup row>
                    <Label style={{ textAlign: 'right' }} sm={2}>
                        Container Id
                    </Label>
                    <Col sm={8}>
                        <Input state={state} name='content.containerId' />
                    </Col>
                </FormGroup>
            </Card>
        </>
    );
}
